import {useEffect, useState} from "react";
import {isEmpty} from "lodash";
import {useDispatch, useSelector} from "react-redux";
import {toast} from "react-toastify";
import {cloneProfile} from "../../../redux/Actions/cloneProfile.actions";
import {requestCustomersLabelValue} from "../../../redux/Actions/customers.actions";
import {
  requestControllersForScope,
  requestScope,
  storeControllersForScope,
  storeScope,
} from "../../../redux/Actions/general.actions";
import {getSelectedController} from "../../../redux/Selectors/controllers.selectors";
import {getCustomersLabelValueList} from "../../../redux/Selectors/customers.selectors";
import {
  getControllersForScope,
  getScope,
} from "../../../redux/Selectors/general.selectors";

export const useFormData = () => {
  const dispatch = useDispatch();
  const controllersForScope = useSelector(getControllersForScope);
  const customersLabelValueList = useSelector(getCustomersLabelValueList);
  const customerScope = useSelector(getScope);
  const selectedController = useSelector(getSelectedController);
  const [payload, setPayload] = useState({appliance: null, customer: null, scope: []});
  const {appliance} = payload;

  useEffect(() => {
    dispatch(requestCustomersLabelValue());

    return () => {
      dispatch(storeScope([]));
      dispatch(storeControllersForScope([]));
    };
  }, [dispatch]);

  const requestScopeForCustomer = (customer) => {
    if (customer) {
      dispatch(requestScope(() => {}, customer));
    } else {
      dispatch(storeScope([]));
    }
  };

  const requestControllers = (scope) => {
    if (isEmpty(scope)) {
      dispatch(storeControllersForScope([]));
    } else {
      dispatch(
        requestControllersForScope({
          scope,
          system_profile: selectedController.properties.appliance_type,
        })
      );
    }
  };

  const handleChange = (key, value) => {
    if (key === "customer") {
      setPayload({customer: value, scope: [], appliance: null});
      requestScopeForCustomer(value);
      return;
    } else if (key === "scope") {
      setPayload({...payload, [key]: value, appliance: null});
      requestControllers(value);
      return;
    }
    setPayload({...payload, [key]: value});
  };

  const handleSubmit = () => {
    if (!appliance) {
      toast.error("Please select required fields.");
      return;
    }
    dispatch(cloneProfile(appliance));
  };

  return {
    applianceOptions: controllersForScope.filter(
      (item) => item.value?.toLowerCase() !== selectedController.mac?.toLowerCase()
    ),
    customerOptions: customersLabelValueList,
    handleChange,
    handleSubmit,
    payload,
    scopeOptions: customerScope,
  };
};
